/*
This registry is maintained in order of zIndex
Highest z-index is at the top lowest z-index is added at the bottom
*/

const MAX_ALLOWED_Z_INDEX = 2147483647;

export default {
  alerts: MAX_ALLOWED_Z_INDEX, // highest z-index
  tooltip: 903, // must be above modal
  popper: 902,
  modalBody: 901, // must be above the modal container
  modalContainer: 900,
  backgroundPopper: 899,
  closeButton: 10,
  datePickerCalendar: 5,
  datePickerFieldIcon: 3,
  datePickerNavigation: 1,
  verificationIconButtonPopper: 1,
  stickyHeaderCell: 1,
  zero: 0,
  max: MAX_ALLOWED_Z_INDEX
};
